import React, { Component } from 'react';

import { listOpenTables, OPEN_TABLE_STATUS, CHARGE_MODE_LABEL } from '../utils/openTablesApi';
import { navigateTo } from '../utils/navigation';
import { copyLink, openTablePublicUrl } from '../utils/publicLinks';

// Grilla de mesas abiertas (molde: TableEventsComponent). El backend devuelve el shape
// admin: fecha/hora de la reserva + mesa física + contador de anotados.

const pad = (n) => String(n).padStart(2, '0');
// Formatea un DATEONLY ('YYYY-MM-DD') sin pasar por Date (evita el off-by-one por TZ).
const fmtYMD = (ymd) => {
    if (!ymd) return '—';
    const [y, m, d] = String(ymd).slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
};

class TableOpenTablesComponent extends Component {

    constructor() {
        super();
        this.state = {
            statusFilter: 'published',
            data: [],
            loaded: false,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async ({ status = this.state.statusFilter } = {}) => {
        this.setState({ loaded: false });
        try {
            const data = await listOpenTables(status || undefined);
            this.setState({
                data: (data && data.openTables) || [],
                statusFilter: status,
                loaded: true,
            });
        } catch (error) {
            console.error('No se pudieron cargar las mesas abiertas:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ data: [], statusFilter: status, loaded: true });
        }
    }

    onChangeStatus = (e) => {
        this.fetchData({ status: e.target.value });
    }

    drawRow = (item, index) => {
        const status = OPEN_TABLE_STATUS[item.status] || { label: item.status, badge: 'badge-light' };
        // "Anotados" = lugares confirmados (los que van a venir). `taken` incluye además los
        // holds de pago online sin acreditar: se muestran aparte, como en eventos.
        const holds = Math.max(0, Number(item.taken) - Number(item.confirmed));
        return (
            <tr role="row" key={item.id} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                <td>{fmtYMD(item.date)}</td>
                <td>{pad(item.startHour)}:00</td>
                <td>{item.tableLabel || '—'}</td>
                <td>{item.gameName || '—'}</td>
                {/* Quién la abrió (spec-mesa-abierta FR-081): un anfitrión habilitado desde su
                    cuenta de la tienda, o el local desde esta pantalla. */}
                <td>{item.hostName || <span className="text-muted">Local</span>}</td>
                <td>
                    {item.confirmed}/{item.cupo}
                    {holds > 0 && <small className="text-muted"> (+{holds} pend.)</small>}
                </td>
                <td>${item.price}</td>
                <td>{CHARGE_MODE_LABEL[item.chargeMode] || item.chargeMode}</td>
                <td><span className={`badge ${status.badge}`}>{status.label}</span></td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white" onClick={() => navigateTo(`/editOpenTable/${item.id}`)}>
                        Editar
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary ml-2" onClick={() => navigateTo(`/openTableSignups/${item.id}`)}>
                        Inscripciones
                    </button>
                    {/* Incluye las que publica un anfitrión desde la tienda, que no pasan por el alta. */}
                    {item.status === 'published' && (
                        // Sólo el ícono: la grilla ya no entraba en pantallas chicas con dos botones.
                        <button type="button" className="btn btn-sm btn-outline-secondary ml-2" title={`Copiar link: ${openTablePublicUrl(item.id)}`}
                            aria-label="Copiar link" onClick={() => copyLink(openTablePublicUrl(item.id))}>
                            <i className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle' }}>link</i>
                        </button>
                    )}
                </td>
            </tr>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }
        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="10" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        No hay mesas abiertas para mostrar.
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_filter" style={{ marginBottom: '1rem' }}>
                    {/* "Realizadas" = 'done'. La mesa pasa sola cuando el salón libera la reserva
                        y, si nadie la liberó, el backend cierra las de jornadas pasadas en la
                        apertura de caja: "Publicadas" queda con las que todavía vienen. */}
                    <label>Estado:&nbsp;
                        <select className="custom-select" style={{ width: 'auto', display: 'inline-block' }} value={this.state.statusFilter} onChange={this.onChangeStatus}>
                            <option value="">Todas</option>
                            <option value="published">Publicadas</option>
                            <option value="done">Realizadas</option>
                            <option value="cancelled">Canceladas</option>
                        </select>
                    </label>
                </div>

                {!this.state.loaded ? this.renderLoader() : (
                    <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid">
                        <thead>
                            <tr role="row">
                                <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>Fecha</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '6%' }}>Hora</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '8%' }}>Mesa</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '15%' }}>Juego</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '13%' }}>Abierta por</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '9%' }}>Anotados</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '7%' }}>Precio</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '11%' }}>Cobro</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '8%' }}>Estado</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '13%' }}></th>
                            </tr>
                        </thead>
                        {this.loadData()}
                    </table>
                )}
            </div>
        );
    }
}

export default TableOpenTablesComponent;
